import { render } from "./TokenizationPage.vue?vue&type=template&id=382154c9&scoped=true"
import script from "./TokenizationPage.vue?vue&type=script&lang=js"
export * from "./TokenizationPage.vue?vue&type=script&lang=js"

import "./TokenizationPage.vue?vue&type=style&index=0&id=382154c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382154c9"]])

export default __exports__